import useMutation from "src/hooks/useMutation";

function useProdGroupUpdate(id) {
  return useMutation({
    path: `/api/v1/product-groups/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/product-groups`,
      shouldRevalidate: true,
    },
  });
}

export default useProdGroupUpdate;
